let physicsWorker: Worker | null = null;

export const getPhysicsWorker = () => physicsWorker;

export const setPhysicsWorker = (worker: Worker | null) => {
  physicsWorker = worker;
};

export const hasPhysicsWorker = () => physicsWorker !== null;
